module.exports = __webpack_public_path__ + "img/article_1_1.68abbf5f.jpg";